import React from 'react';
import HorizontalMenu from './HorizontalMenu';

const HorizontalToolbar = ({ routes, match, readOnly }) => {
  return (
    <div className=" gx-header-horizontal-nav gx-d-none gx-d-lg-block">
      <HorizontalMenu routes={routes} match={match} readOnly={readOnly} />
      <ul className="gx-header-notifications gx-ml-auto">
        <li className="gx-user-nav" />
      </ul>
    </div>
  );
};

export default HorizontalToolbar;
